import { InjectionToken } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApplicationMode, SynchronizationStatus } from './synchronisation-types';

export const APPLICATION_MODE = new InjectionToken<Observable<ApplicationMode>>('APPLICATION_MODE');
export const applicationMode$ = new BehaviorSubject<ApplicationMode>('offline');

export const SERVER_AVAILABLE = new InjectionToken<Observable<boolean>>('SERVER_AVAILABLE');
export const serverAvailable$ = new BehaviorSubject<boolean>(false);

export const INITIAL_SYNCHRONIZATION_STATE: SynchronizationStatus = {
    running: false,
    partName: undefined,
    stepName: undefined,
    totalSteps: 0,
    currentStep: 0,
    unsyncedCount: 0,
};
export const ONLINE_CHECK_INTERVAL = 5 * 1000; // Contrôle de la connectivité toutes les 5 secondes
export const SYNCHRONIZATION_INTERVAL = 5 * 60 * 1000; // Synchronisation automatique toutes les 5 minutes
export const OFFLINE_DELAY_CHECK_INTERVAL = 5 * 60 * 1000; // Contrôle du délai d'utilisation hors-ligne toutes les 5 minutes

export const OFFLINE_DELAY_HOURS = 4; // Délai avant d'afficher un message invitant l'utilisateur à se connecter
export const OFFLINE_DELAY_REACHED = new InjectionToken<Observable<boolean>>('OFFLINE_DELAY_REACHED');
export const offlineDelayReached$ = new BehaviorSubject<boolean>(false);

export const FORCE_OFFLINE_STATE = new InjectionToken<Observable<boolean>>('FORCE_OFFLINE_STATE');
export const forceOfflineState$ = new BehaviorSubject<boolean>(false);

export const INVALID_UNSYNCED_DATA = new InjectionToken<Observable<boolean>>('INVALID_UNSYNCED_DATA');
export const invalidUnsyncedData$ = new BehaviorSubject<boolean>(false);
